import type { ForwardRefRenderFunction } from "react"
import React, { forwardRef, useImperativeHandle, useCallback, useRef } from "react"
import type { ChoiceGroupDataVO, CustomizeRangeDataVO } from "@/api"
// ==============================================
import ChoiceGroup from "../ChoiceGroup"
import CustomizeRange from "../CustomizeRange"
// ==============================================
interface UnitCombinationVO {
  choice: ChoiceGroupDataVO
  customize?: CustomizeRangeDataVO
}
const UnitCombination: ForwardRefRenderFunction<any, UnitCombinationVO> = (
  { choice, customize },
  ref,
) => {
  const CustomizeRangeRef = useRef<any>()
  const ChoiceGroupRef = useRef<any>()

  // 清空group
  const clearGroup = useCallback(() => {
    ChoiceGroupRef.current?.clearValues()
  }, [])

  // 清空customize
  const clearCustomize = useCallback(() => {
    CustomizeRangeRef.current?.clearValues()
  }, [])

  // 获取值
  const getValues = useCallback(() => {
    const { options, names } = ChoiceGroupRef.current?.getValues()
    const range = CustomizeRangeRef.current?.getValues()
    return {
      title: choice.title || "",
      unit: customize?.unit || "",
      options,
      names,
      range,
    }
  }, [choice, customize])

  // 自定义校验函数
  const rangeVerify = useCallback(() => {
    if (CustomizeRangeRef.current?.rangeVerify) {
      return CustomizeRangeRef.current?.rangeVerify()
    } else {
      return true
    }
  }, [])

  // 传递方法到父组件
  useImperativeHandle(ref, () => ({
    getValues,
    rangeVerify,
  }))

  return (
    <div>
      {/* group */}
      <ChoiceGroup ref={ChoiceGroupRef} data={choice} changeCallback={clearCustomize} />
      {/* 自定义 */}
      {customize && (
        <CustomizeRange ref={CustomizeRangeRef} data={customize} changeCallback={clearGroup} />
      )}
    </div>
  )
}

export default forwardRef(UnitCombination)
